<template>
  <button
    :data-id="dataId"
    class="transition-all duration-300 outline-none bl-button"
    :class="[
      type ? `bl-button-${type}` : '',
      icon ? 'bl-button-icon' : '',
      label ? 'bl-button-label' : '',
      loading ? 'bl-button-loading cursor-wait' : '',
      disabled ? 'bl-button-disabled' : '',
      reverse ? 'bl-button-reverse' : '',
      type.includes('dense') || dense ? 'bl-button-dense' : ''
    ]"
    :disabled="disabled || loading"
    @click="$emit('clicked')"
    :type="buttonType"
    :title="title || label"
  >
    <BlIcon
      v-if="icon"
      :dataId="dataId"
      class="bl-button-icon"
      :class="[type.includes('dense') || dense ? 'bl-icon-dense' : '']"
      :icon="icon"
      :color="getColor(type)"
    />
    <label v-if="label" :data-id="dataId" class="truncate bl-button-label">
      {{ label }}
    </label>
  </button>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlTextBody3 from "./BlTextBody3.vue";

export default {
  components: {
    BlIcon,
    BlTextBody3
  },
  name: "BlButton",
  props: {
    dataId: { type: String, default: "bl-button" },
    title: { type: String },
    label: { type: String },
    icon: { type: String },
    type: { type: String, default: "primary" },
    buttonType: { type: String, default: "button" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    dense: { type: Boolean, default: false }
  },
  methods: {
    getColor(type) {
      if (this.disabled) return "slate-6";
      let color = "secondary";
      switch (type) {
        case "outlined":
          color = "primary";
          break;
        case "outlined-teal":
          color = "teal-7";
          break;
        case "outlined-error":
          color = "error";
          break;
        case "plain":
          color = "primary";
          break;
        case "plain-error":
          color = "error";
          break;
        case "plain-lime":
          color = "lime";
          break;
        default:
          color = "secondary";
          break;
      }
      return color;
    }
  }
};
</script>

<style scoped lang="scss">
.bl-button {
  position: relative;
  width: auto;
  height: 2.375rem;
  background: var(--primary-color);
  border-radius: 5px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  &:hover {
    background: var(--dark-purple-two);
  }
  &.bl-button-dense {
    height: 1.875rem;
  }
  &.bl-button-icon {
    &:not(.bl-button-label) {
      width: 2.375rem;
      box-sizing: border-box;
      &.bl-button-dense {
        width: 1.875rem;
      }
    }
    .bl-button-icon {
      pointer-events: none;
      position: relative;
      width: 1.5rem;
      height: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      &.bl-icon-dense {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
  &.bl-button-reverse {
    flex-direction: row-reverse;
    .bl-button-label {
      margin-left: 0;
      margin-right: 0.5rem;
    }
  }
  &.bl-button-label {
    padding: 0 1rem 0 1rem;
    .bl-button-label {
      pointer-events: none;
      position: relative;
      font-weight: 600;
      font-size: 0.875rem;
      letter-spacing: 0.5px;
      color: #fff;
      white-space: nowrap;
    }
    &.bl-button-dense {
      padding: 0 0.5rem 0 0.5rem;
    }
  }
  // type
  &.bl-button-plain {
    background: transparent;
    .bl-button-label {
      color: var(--primary-color);
    }
  }
  &.bl-button-plain-error {
    background: transparent;
    .bl-button-label {
      color: var(--error-color);
    }
  }
  &.bl-button-plain-lime {
    background: transparent;
    .bl-button-label {
      color: #789719;
    }
  }
  &.bl-button-error {
    background: var(--error-color);
    &:hover {
      background-color: var(--error-five);
    }
  }
  &.bl-button-orange {
    background: #ec4a0a;
  }
  &.bl-button-lime {
    background: #789719;
  }
  &.bl-button-teal {
    background: #1d847f;
    &:hover {
      background-color: #1a5554;
    }
  }
  &.bl-button-outlined {
    background: var(--Greyscale-Pure-White, #fff);
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    &:hover {
      background-color: var(--grey-two);
    }
    .bl-button-label {
      color: var(--primary-color);
    }
  }
  &.bl-button-outlined-error {
    background: var(--Greyscale-Pure-White, #fff);
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    &:hover {
      background-color: var(--grey-two);
    }
    .bl-button-label {
      color: var(--error-color);
    }
  }
  &.bl-button-outlined-teal {
    background: var(--Greyscale-Pure-White, #fff);
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    &:hover {
      background-color: var(--grey-two);
    }
    .bl-button-label {
      color: #1d847f;
    }
  }
  //
  &.bl-button-loading {
    // pointer-events: none;
    // opacity: 0.5;
    cursor: wait;
    background-color: var(--Slate-4, #eaecf0);
    &:hover {
      background-color: var(--Slate-4, #eaecf0);
    }
  }
  &.bl-button-disabled {
    // pointer-events: none;
    opacity: 0.5;
    cursor: default;
    background-color: var(--Slate-4, #eaecf0);
    &:hover {
      background-color: var(--Slate-4, #eaecf0);
    }
    .bl-button-label {
      color: var(--Slate-6, #98a2b3);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputButton.vue